<template>
  <div class="seller">
    <nav class="nav">
      <div class="container">
        <div class="nav__list">
          <div class="nav__link">Bid</div>
          <span>/</span>
          <router-link
            class="nav__link"
            to="/"
          >
            My Home
          </router-link>
          <span>/</span>
          <div class="nav__link nav__link--active">{{ sellerName }}</div>
        </div>
        <div class="nav__button">
          <a href="https://docs.gmsm.app" target="_blank">Docs</a>
        </div>
      </div>
    </nav>
    <main v-if="this.adapters.length">
      <div class="container container--content">
        <div class="seller__content">
          <h2 class="seller__title">{{ sellerName }}</h2>
          <div class="seller__chart">
            <charts :options="chartOptions" />
          </div>
        </div>
      </div>
      <Logo />
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { types } from '../store';
// eslint-disable-next-line import/extensions
import Logo from '../components/Logo';

export default {
  components: {
    Logo,
  },
  computed: {
    ...mapGetters({
      adapters: types.GET_SELECTED_SELLER,
    }),
    sellerName() {
      return this.adapters[0].seller;
    },
    chartOptions() {
      if (this.adapters.length) {
        return {
          title: {
            text: '',
          },
          chart: {
            marginTop: 60,
            height: 360,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            spacingTop: 0,
          },
          legend: {
            align: 'left',
            verticalAlign: 'top',
            itemStyle: {
              fontWeight: '400',
              color: '#516586',
              fontSize: '14px',
              lineHeight: '16px',
            },
            symbolRadius: 6,
            symbolHeight: 12,
            symbolWidth: 12,
          },
          tooltip: {
            shared: true,
            useHTML: true,
            backgroundColor: '#fff',
            borderRadius: 4,
            borderWidth: 0,
            padding: 10,
            headerFormat: `
              <span
                class="seller-chart-pointformat"
              >
                <span>Date:</span> {point.key}
              </span>
              <br/>
            `,
            pointFormat: `
              <span
                class="seller-chart-pointformat"
              >
                <span>{series.name}:</span>
                <b>{point.y}</b>
              </span>
              <br/>
            `,
            shadow: {
              color: 'rgba(0, 0, 0, 0.05)',
              offsetY: 2,
              width: 11,
            },
            style: {
              color: '#3A5177',
              fontSize: '12px',
            },
          },
          xAxis: {
            type: 'category',
            labels: {
              style: {
                fontSize: '12px',
                lineHeight: '14px',
                color: '#3A5177',
              },
            },
            title: {
              margin: 16,
              text: 'Date',
              style: {
                fontSize: '12px',
                lineHeight: '15px',
                fontWeight: '500',
                color: '#0A2756',
              },
            },
          },
          yAxis: [
            {
              title: {
                margin: 16,
                text: 'Bid requests',
                style: {
                  fontSize: '12px',
                  lineHeight: '15px',
                  fontWeight: '500',
                  color: '#0A2756',
                },
              },
              labels: {
                style: {
                  fontSize: '12px',
                  lineHeight: '14px',
                  color: '#3A5177',
                },
              },
            },
            {
              opposite: true,
              title: {
                margin: 24,
                text: 'Bid rate (%)',
                style: {
                  fontSize: '12px',
                  lineHeight: '15px',
                  fontWeight: '500',
                  color: '#0A2756',
                },
              },
              labels: {
                style: {
                  fontSize: '12px',
                  lineHeight: '14px',
                  color: '#3A5177',
                },
              },
            },
          ],
          plotOptions: {
            series: {
              states: {
                hover: {
                  halo: {
                    size: 0,
                  },
                },
              },
            },
          },
          series: [
            {
              type: 'column',
              name: 'Bid requests',
              data: this.adapters.map(item => [
                item.date.value,
                item.requests,
              ]),
              color: '#DEAC47',
              borderRadiusTopLeft: '4px',
              borderRadiusTopRight: '4px',
            },
            {
              type: 'spline',
              name: 'Bid rate (%)',
              // 0.01 means 1%, so we need to * 100
              data: this.adapters.map(item => +(item.bid_rate * 100).toFixed(2)),
              color: '#026CD9',
              lineWidth: 3,
              yAxis: 1,
              marker: {
                width: 16,
                enabled: false,
                fillColor: '#fff',
                lineColor: '#026CD9',
                lineWidth: 3,
                lineWidthPlus: 0,
                states: {
                  hover: {
                    fillColor: '#fff',
                    lineColor: '#026CD9',
                    lineWidth: 3,
                    lineWidthPlus: 0,
                  },
                },
              },
              borderRadius: '4px',
            },
          ],
        };
      }
      return {};
    },
  },
  mounted() {
    if (!this.adapters.length) {
      this.$router.push('/');
    }
  },
};
</script>
<style lang="scss">
.seller-chart-pointformat {
  font-size: 12px;
  line-height: 14px;
  color: #0A2756;
  font-weight: 400;

  & > span {
    width: 75px;
    display: inline-block;
    font-weight: 500;
  }
}
</style>
<style lang="scss" scoped>
main {
  background-color: #F1F2F4;
  min-height: calc(100vh - 50px);
  padding-bottom: 32px;

  h1 {
    padding: 24px 0;
    color: #0A2756;
    font-size: 22px;
    font-weight: 500;
    line-height: 27px;
  }
}
.container {
  width: 100%;
  max-width: 1240px;
  padding: 0 20px;
  margin: 0 auto;
}
.container--content {
  padding-top: 24px;
}
.nav {
  padding: 16px 0;
  box-shadow: 0 4px 12px 0 #E3E6EA;
  height: 50px;
  box-sizing: border-box;
}
.nav__list {
  display: flex;

  span {
    color: #99A5B7;
  }
}
.nav__link {
  margin: 0 8px;
  color: #0080FF;
  font-size: 14px;
  line-height: 16px;
  text-decoration: none;

  &:first-child {
    margin-left: 0;
  }

  &--active {
    color: #213B65;
  }
}
.nav__button {
  margin: -15px 20px;
  font-size: 12px;
  color: #0080FF;
  float: right;
  padding: 4px;
  border-radius: 6px;
  background-color: rgba(0, 128, 255, 0.2);

  a {
    text-decoration: none;
  }
}
.seller__content {
  border-radius: 2px;
  background-color: #fff;
  box-shadow: 0 4px 12px 0 #E3E6EA;
}
.seller__title {
  padding: 16px 24px;
  color: #0A2756;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.21px;
  line-height: 19px;
  border-bottom: 1px solid #E8EBEF;
}
.seller__chart {
  padding: 24px;
  border-radius: 2px;
}
</style>
